module.exports = __webpack_public_path__ + "static/media/logo_old.201d9c7a.png";